import { render, staticRenderFns } from "./InstallmentProgram.vue?vue&type=template&id=84f22bca&scoped=true&"
import script from "./InstallmentProgram.vue?vue&type=script&lang=js&"
export * from "./InstallmentProgram.vue?vue&type=script&lang=js&"
import style0 from "./InstallmentProgram.vue?vue&type=style&index=0&id=84f22bca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f22bca",
  null
  
)

export default component.exports